"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useState } from "react";
import { Server } from "lucide-react";
import { ToolIcon } from "@/components/ToolIcon";
import type { Tool } from "@/lib/tools";
export function ToolCard(t0) {
  const $ = _c(19);
  const {
    tool,
    onClick
  } = t0;
  const [warm, setWarm] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setWarm(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const prefetch = t1;
  const t2 = `/${tool.slug}/`;
  const t3 = warm ? null : false;
  let t4;
  if ($[1] !== tool.category) {
    t4 = <ToolIcon category={tool.category} />;
    $[1] = tool.category;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== tool.name) {
    t5 = <span className="text-[17px] font-semibold">{tool.name}</span>;
    $[3] = tool.name;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== tool.description) {
    t6 = <span className="text-sm text-muted-foreground">{tool.description}</span>;
    $[5] = tool.description;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== tool.runsOn) {
    t7 = tool.runsOn === "server" && <span className="mt-1 inline-flex items-center gap-1 text-[13px] font-semibold text-brand-strong"><Server className="size-3.5" aria-hidden="true" />Uses our server</span>;
    $[7] = tool.runsOn;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <span className="flex flex-col gap-0.5">{t5}{t6}{t7}</span>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== onClick || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t8) {
    t9 = <Link href={t2} prefetch={t3} onPointerEnter={prefetch} onFocus={prefetch} onTouchStart={prefetch} onClick={onClick} className="flex items-start gap-3.5 rounded-[14px] border bg-card p-5 text-ink transition-colors hover:border-line-strong hover:bg-canvas">{t4}{t8}</Link>;
    $[13] = onClick;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}